import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { ExpenseActions } from './expense.actions';

@Injectable({
  providedIn: 'root'
})
export class ExpenseEffects {
  sendExpenseEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendExpenseEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(ExpenseActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
